import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux'; // Correctly imported
import { Dropdown, Menu, Icon, Label } from 'semantic-ui-react'; // Import Menu, Icon, and Label
import logo from './logo.png';
import SideBar from '../SideBar/SideBar';
import burgerMenu from './icons8-menu.svg';
import ProfilePictureWithBadge from '../../common/ProfilePictureWithBadge'; // Assuming this component exists
import PromotionsCarousel from '../../Admin/PromotionsCarousel';
import { auth } from '../../../firebase/firebase';
import './navbar.css';

const NavBar = () => {
  const [visible, setVisible] = useState(false);
  const currentUser = useSelector((state) => state.currentUser);
  const { items: cartItems } = useSelector((state) => state.cart);
  const history = useHistory();

  // Calculate the total number of items in the cart
  const totalItemsInCart = cartItems.reduce((total, item) => total + item.quantity, 0);

  const handleClick = () => {
    setVisible(!visible);
  };

  const handleSignOut = async () => {
    await auth.signOut();
    history.push('/');
  };

  const trigger = (
    <span>
      <ProfilePictureWithBadge user={currentUser} avatar />
      <span style={{ marginLeft: '0.5em' }}>{currentUser?.displayName || 'My Account'}</span>
    </span>
  );

  return (
    <div>
      <PromotionsCarousel />
      <div>
        <div className="ui tiny menu">
          <Link to="/" className="ui hamburger small image">
            <img src={logo} alt="logo" className="logo" />
            <p id="logoSubText" className="mobile-logo-subtext">
              Boat Rental By Owner
            </p>
            <p style={{color: 'red', margin: '-10px 0px 5px 22px', font: 'caption'}}>
              & Marketplace
            </p>
          </Link>
          {/* Mobile Cart Icon - Always visible in the NavBar */}
          <Menu.Item as={Link} to="/cart" className="mobile-nav-cart-icon">
            <Icon name="shopping cart" />
            {totalItemsInCart > 0 && (
              <Label color="red" floating>
                {totalItemsInCart}
              </Label>
            )}
          </Menu.Item>
          <div className="hamburger right menu" onClick={handleClick}>
            <img
              alt="hamburgermenu"
              src={burgerMenu}
              className="hamburger-icon"
            />
          </div>
        </div>
        <SideBar
          isVisible={visible}
          handleClick={handleClick}
          currentUser={currentUser}
          // Pass cart data to the sidebar
          cart={{
            items: cartItems,
            totalItems: totalItemsInCart,
          }}
          auth={auth}
        />
        <div
          className={`pusher ${visible ? 'dimmed' : ''}`}
          onClick={handleClick}
        ></div>
      </div>
      {currentUser ? (
        <div className="ui large menu" style={{ marginTop: '0px' }}>
          <Link to="/" className="ui fullscreen small image">
            <img src={logo} alt="logo" className="logo" />
            <p id="logoSubText">Boat Rental By Owner</p>
            <p style={{color: 'red', margin: '-10px 0px 5px 22px', font: 'caption'}}>
              & Marketplace
            </p>            
          </Link>
         
          <div className="fullscreen right menu">           
            <Link to={{ pathname: "/boatresults", state: { findNearMe: true } }} className="item">
              <div className="ui primary button">Boats Near Me</div>
            </Link> 
            <Link to={{ pathname: "/boatresults", state: { clearSearch: true } }} className="item item4">
              <div className="ui primary button">Rent A Boat</div>
            </Link>
            <Link to="/listaboat" className="item">
              <div className="ui primary button">List A Boat</div>
            </Link>       
            <Link to="/products" className="item">
              <div className="ui primary button">Marketplace</div>
            </Link>                    
            <Menu.Item as={Link} to="/cart" name="cart">
              <Icon name="shopping cart" />
              Cart
              {totalItemsInCart > 0 && (
                <Label color="red" floating>
                  {totalItemsInCart}
                </Label>
              )}
            </Menu.Item>
            <Dropdown item trigger={trigger} pointing="top right">
              <Dropdown.Menu>
                {currentUser.roles?.admin === true && (
                  <Dropdown.Item
                    as={Link}
                    to="/admin"
                    text="Admin Dashboard"
                    icon="user secret"
                  />
                )}                
                <Dropdown.Item as={Link} to="/captain-profile" text="Dashboard" icon="dashboard" />
                <Dropdown.Item as={Link} to="/my-favorites" text="Favorites" icon="heart" />
                <Dropdown.Item as={Link} to="/following" text="Following" icon="users" />
                <Dropdown.Item as={Link} to="/products" text="Marketplace" icon="shop" />
                <Dropdown.Item as={Link} to="/message" text="Messages" icon="envelope" />
                <Dropdown.Item as={Link} to="/boats" text="My Boats" icon="ship" />
                <Dropdown.Item as={Link} to="/my-products" text="My Products" icon="shop" />                  
                <Dropdown.Item as={Link} to="/my-purchases" text="Purchases" icon="shopping bag" />                
                <Dropdown.Item as={Link} to="/my-reservations" text="Reservations" icon="compass" />  
                <Dropdown.Item as={Link} to="/settings" text="Settings" icon="settings" />                                                                                                                           
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleSignOut} text="Sign Out" icon="sign-out" />
              </Dropdown.Menu>
            </Dropdown>           
          </div>
        </div>
      ) : (
        <div className="ui large menu" style={{ marginTop: '0px' }}>
          <Link to="/" className="ui fullscreen small image">
            <img src={logo} alt="logo" className="logo" />
            <p id="logoSubText">Boat Rental By Owner</p>
            <p style={{color: 'red', margin: '-10px 0px 5px 22px', font: 'caption'}}>
              & Marketplace
            </p>            
          </Link>
          <div className="fullscreen right menu">
            <Link to="/login" className="item item1">
              Sign In
            </Link>
            <Link to="/signUp" className="item item2">
              Sign Up
            </Link>
           <Link to={{ pathname: "/boatresults", state: { findNearMe: true } }} className="item">
              <div className="ui primary button">Boats Near Me</div>
            </Link>            
            <Link to={{ pathname: "/boatresults", state: { clearSearch: true } }} className="item item4">
              <div className="ui primary button">Rent A Boat</div>
            </Link>
            <Link to="/products" className="item">
              <div className="ui primary button">Marketplace</div>
            </Link>            
            <Menu.Item as={Link} to="/cart" name="cart">
              <Icon name="shopping cart" />
              Cart
              {totalItemsInCart > 0 && (
                <Label color="red" floating>
                  {totalItemsInCart}
                </Label>
              )}
            </Menu.Item>
            <Link to="/help" className="item item3">
              How It Works
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavBar;
